export const GENERAL_EVENTS = {
  TRACK_FETCH_MATRIX: 'trackFetchMatrix',
  TRACK_FEATURE_USAGE: 'trackFeatureUsage',
  TRACK_WEB_VITAL: 'trackWebVital',
  TRACK_SURVEY: 'trackSurvey',
  FIRST_PAGE_TRACKED: 'firstPageTracked',
};
